import styled from 'styled-components';
import { media } from 'src/components/base';

export const PriceHistoryLinkWrapper = styled.div`
  display: none;

  ${media.largeUp`
      display: block;
    `}
`;
